import React from "react";
import { businessMatchingBusinessEntityTalkRoomsPath } from "../../../../../routes";
import { SharedCurrentUser } from "../../lib/types";

import { Badge, Show, Circle, Box, Link, HStack, Stack, Text } from "@chakra-ui/react";
import MessageIcon from "../icons/MessageIcon";

const hoverStyle = { backgroundColor: "#EDF5F3" };

const MessagesButton = ({ currentUser }: { currentUser: SharedCurrentUser | undefined }) => {
  const business_entity_has_talk_room = currentUser?.business_entity_has_talk_room ?? null;
  if (business_entity_has_talk_room == null) return null;

  return (
    <Link
      px={3}
      href={businessMatchingBusinessEntityTalkRoomsPath(business_entity_has_talk_room.code)}
      textDecoration="none"
      color="inherit"
      _hover={hoverStyle}
      h="full"
      placeContent="center"
      target="_blank"
      rel="noreferrer"
    >
      <ContentsForButton business_entity_has_talk_room={business_entity_has_talk_room} />
    </Link>
  );
};

const ContentsForButton = ({
  business_entity_has_talk_room,
}: {
  business_entity_has_talk_room: NonNullable<NonNullable<SharedCurrentUser>["business_entity_has_talk_room"]>;
}) => {
  const isUnread = business_entity_has_talk_room?.unread_message_count > 0;

  return (
    <>
      <Show above="lg">
        <HStack gap={1}>
          <MessageIcon />
          <Text fontSize="md">メッセージ</Text>
          {isUnread && (
            <Badge
              bg="red.500"
              color="white"
              borderRadius="full"
              fontSize="0.6875rem"
              px={2}
              pt={"3px"}
              pb={0.5}
              minW="20px"
              display="flex"
              alignItems="center"
              lineHeight="1"
            >
              {business_entity_has_talk_room.unread_message_count > 99
                ? "99+"
                : business_entity_has_talk_room.unread_message_count}
            </Badge>
          )}
        </HStack>
      </Show>
      <Show below="lg">
        <Stack gap={0} alignItems="center">
          <Box position="relative">
            <HStack h={7}>
              <MessageIcon boxSize={6} />
            </HStack>
            {isUnread && (
              <Circle
                size="12px"
                bg="red.500"
                position="absolute"
                top="-2px"
                right="-2px"
                border="1px solid white"
                data-testid="unread-badge"
              />
            )}
          </Box>
          <Box fontSize="xs">メッセージ</Box>
        </Stack>
      </Show>
    </>
  );
};

export default MessagesButton;
